export default __webpack_public_path__ + "static/media/step_img_1.2c401ef9.png";